import {CheckIcon, CopyIcon} from '@primer/octicons-react'
import {copyText} from '@github-ui/copy-to-clipboard'
import {type MouseEventHandler, useCallback, useRef, useState} from 'react'
import {useAlertTooltip} from '../hooks/use-alert-tooltip'
import {shortSha} from '../utils/short-sha'

export function CopySHA({sha}: {sha: string}) {
  const defaultLabel = `Copy full SHA for ${shortSha(sha)}`
  const [copied, setCopied] = useState(false)

  const copyButtonRef = useRef(null)
  const [updateTooltipMessage, clearTooltipMessage, portalTooltip] = useAlertTooltip(
    'copy-sha-tooltip',
    copyButtonRef,
    {direction: 's', anchorSide: 'outside-bottom'},
  )

  const clickHandler: MouseEventHandler = useCallback(() => {
    copyText(sha)
    setCopied(true)
    updateTooltipMessage('Copied SHA!')

    setTimeout(() => {
      setCopied(false)
      clearTooltipMessage()
    }, 2000)
  }, [sha, updateTooltipMessage, clearTooltipMessage])

  return (
    <>
      <button
        className="Button Button--iconOnly Button--invisible Button--small"
        aria-label={defaultLabel}
        onClick={clickHandler}
        ref={copyButtonRef}
        onFocus={() => updateTooltipMessage(defaultLabel)}
        onMouseEnter={() => updateTooltipMessage(defaultLabel)}
        onMouseLeave={clearTooltipMessage}
        onBlur={clearTooltipMessage}
        data-testid="copy-full-sha-button"
      >
        {copied ? <CheckIcon /> : <CopyIcon />}
      </button>
      {portalTooltip}
    </>
  )
}

try{ CopySHA.displayName ||= 'CopySHA' } catch {}